module.exports = {
      id: "facebook-usage",
      viewBox: "0 0 7 15",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#facebook",
      toString: function () {
        return this.url;
      }
    }